import ROUTES from 'routes';

export const adminPermission = {
  redirectUrl: ROUTES.DASHBOARD(),
};
